import {Links} from "./links.model";

export class Hal {
    _links: Links;

    constructor(data: any) {
        this._links = new Links(data._links);
    }
}
